import React from "react";
import { useNavigate } from "react-router-dom";
import planImage from "../../assets/images/JesusPlan.png";

const Card = ({ data, length, prefix }) => {
  const navigate = useNavigate();

  const progress = 75;
  const trackProgress = 90;

  const handleMoreClick = (e) => {
    e.stopPropagation(); // prevent parent click if any
    if (!data?._id || !prefix) return;
    navigate(`/${prefix}/${data._id}`);
  };

  return (
    <div className="bg-[#D9D9D9] text-black rounded-xl w-[250px] overflow-hidden shadow-md border-4 border-[#F8BA34] transition hover:shadow-lg p-4">
      {/* Title */}
      <h4 className="font-bold text-sm">
        {data?.details?.planName || data?.details?.journal_title || "Title"}
      </h4>
      <p className="text-xs text-gray-600">{length} day plan</p>

      {/* Image */}
      <div className="my-2 overflow-hidden">
        <img
          src={planImage}
          alt="plan"
          className="w-full h-full object-cover rounded-md"
        />
      </div>

      <div className="space-y-4">
        {/* Progress */}
        <div>
          <p className="text-[14px] font-medium">Bible Plan Progress</p>

          <div className="w-full bg-[#C3C3C3] h-3.5 mb-1 rounded-full overflow-hidden">
            <div
              className="bg-black h-3.5 text-[#F8BA34] text-[10px] text-right pr-2 flex items-center justify-end rounded-full"
              style={{ width: `${progress}%` }}
            >
              {progress}%
            </div>
          </div>

          <p className="flex items-center gap-2">
            <span
              className="relative flex items-center justify-center w-12 h-12 rounded-full"
              style={{
                background: `conic-gradient(black ${trackProgress}%, lightgray ${trackProgress}% 100%)`,
              }}
            >
              <span className="absolute w-10 h-10 bg-[#D9D9D9] rounded-full flex items-center justify-center">
                <span className="text-sm font-semibold">
                  {trackProgress}%
                </span>
              </span>
            </span>

            <span className="text-sm font-medium">Individuals on track</span>
          </p>
        </div>

        {/* Button */}
        <button
          onClick={handleMoreClick}
          className="mt-2 text-sm font-medium bg-[#F8BA34] text-black px-4 py-2 rounded-full shadow-[2px_4px_4px_0px_#00000040]"
        >
          More
        </button>
      </div>
    </div>
  );
};

export default Card;
